'use client';

import {createContext, use} from 'react';

import Storage from '../../utils/Storage';
import {PORTAL_HISTORY} from '../../utils/StorageConstants';

/*
 * Kept out of the provider's own file so that file exports only a component.
 * A module that exports both a component and non-components defeats Fast
 * Refresh: editing it remounts the tree instead of preserving state.
 *
 * The context holds the history array directly (it was the value's only
 * field) instead of a `{history}` wrapper rebuilt every render.
 */
export const HistoryContext = createContext<string[]>(null);

export const historyStorage = new Storage<string[]>(PORTAL_HISTORY, []);

export function useHistory(): string[] {
  return use<string[]>(HistoryContext);
}
